import React, { Component } from 'react';
import { Row } from 'reactstrap';
import graphLogo from '../../../../public/img/GARP_logo.png';
import LoaderWrapper from '../../../Components-2025/QuestionBank/LoaderWrapper';
import VideoCard from '../../../Components-2025/Videos/videoCard';
import ComponentHeader from '../../../common/ComponentHeader';
import { messages } from '../../../common/messages';
import { chapterIdKey, chapterNameKey, lastVideoViewTableNameKey, videoTableNameKey } from './ApiAttributesKays';
import apiServiceProvider from './ApiService';
import ModalComponent from '../../Common/Modal';
import alertMessage from '../../config/alertMessage';
import config from '../../config/AppRoutes';
import { showInformation } from '../../../common/toast';
import { CAPSULE_VIDEO_ID, FRM_LEVELS } from '../../../common/constant';

export default class index extends Component {
  static contextTypes = { router: React.PropTypes.object };
  constructor(props) {
    super(props);
    this.state = {
      videoDataPart1: [],
      videoDataPart2: [],
      isLoading: true,
      openPremiumPopup: false,
      isUserSubscribedPart1: false,
      isUserSubscribedPart2: false,
      isUserSubscribedBoth: false,
    };
  }
  async componentDidMount() {
    this.setState({ isLoading: true });
    await this.getChapterWiseVideos({ level: 1 });
    await this.getChapterWiseVideos({ level: 1, chapterId: 11 });
    this.getChapterWiseVideos({ level: 2 });
  }
  getChapterWiseVideos = async payload => {
    const result = await apiServiceProvider['fetchVideos'](payload);
    if (result.success) {
      let videosData = result.data;

      if (payload.chapterId === 11) {
        const { videoDataPart1 } = this.state;
        videosData = [
          ...videoDataPart1,
          {
            chapter_name: messages.FRM_CAPSULES_CHAPTER_NAME,
            chapter_no: 11,
            id: 11,
            frm_videos: result.data,
          },
        ];
      }
      this.setState({
        isLoading: false,
        [`videoDataPart${payload.level}`]: videosData.length ? videosData : result.data,
        [`isUserSubscribedPart${payload.level}`]:
          result.selectedExamSubscriptionDetails[`subscriptionDetailsForFrm${payload.level}`] &&
          result.selectedExamSubscriptionDetails[`subscriptionDetailsForFrm${payload.level}`]
            .videoStatus,
        isUserSubscribedBoth:
          result.selectedExamSubscriptionDetails['subscriptionDetailsForFrm1And2'] &&
          result.selectedExamSubscriptionDetails.subscriptionDetailsForFrm1And2.videoStatus,
      });
    } else {
      this.setState({ isLoading: false });
    }
  };
  goPremium = () => {
    const { router } = this.context;
    router.push({ pathname: '/Subscribe' });
  };
  toggleAlert = () => {
    this.setState({ openPremiumPopup: !this.state.openPremiumPopup });
  };
  redirectToPlaylist = async (items) => {
    const { router } = this.context;
    const { level, chapter_id, id, mock_id } = items;
    const payLoad = {
      video_id: id,
      level,
    };
    await apiServiceProvider['saveLastViewedVideo'](payLoad);
    router.push({
      pathname: mock_id ? config.FRM_V2_VIDEOS_MOCK_PLAYLIST.replace(':mockId', mock_id)
        .replace(':level', level)
        .replace(':id', id) : config.FRM_V2_VIDEOS_PLAYLIST.replace(':chapterId', chapter_id)
          .replace(':level', level)
          .replace(':id', id),
    });
  };
  //* ============================{{ REDIRECTION FUNCTION START HERE }}========================================
  redirectToLastViewedVideo = async level => {
    this.setState({ [`isButtonDisablePart${level.level}`]: true });
    const result = await apiServiceProvider['fetchLastViewedVideo'](level);
    this.setState({ [`isButtonDisablePart${level.level}`]: false });

    if (result.success) {
      const { data } = result;
      const { router } = this.context;
      const lastVideo = data[lastVideoViewTableNameKey];

      const videoPathName = lastVideo.mock_id
        ? config.FRM_V2_VIDEOS_MOCK_PLAYLIST.replace(':mockId', lastVideo.mock_id)
        : config.FRM_V2_VIDEOS_PLAYLIST.replace(':chapterId', lastVideo.chapter_id);

      router.push({
        pathname: videoPathName
          .replace(':level', lastVideo.level)
          .replace(':id', lastVideo.id),
      });
    } else {
      showInformation(messages.VIDEO_NOT_AVAILABLE);
    }
  };

  createVideoCard = ({
    item,
    idx,
    type = "",
    level,
    isUserSubscribedBoth,
    isUserSubscribedPart1,
    isUserSubscribedPart2,
    toggleAlert,
    redirectToPlaylist
  }) => {
    const isUserSubscribed =
      level === FRM_LEVELS.ONE
        ? Boolean(isUserSubscribedBoth || isUserSubscribedPart1)
        : Boolean(isUserSubscribedBoth || isUserSubscribedPart2);

    return (
      <VideoCard
        key={`${type}-${item.id || item.chapter_id || Math.random()}`}
        index={idx + 1}
        currentItem={item}
        chapterIdKey={chapterIdKey}
        chapterNameKey={chapterNameKey}
        videoTableNameKey={videoTableNameKey}
        isUserSubscribed={isUserSubscribed}
        premiumModalToggle={toggleAlert}
        redirectToPlaylist={redirectToPlaylist}
      />
    );
  };

  renderVideoCards = ({ state, level, toggleAlert, redirectToPlaylist }) => {
    const chapters = state[`videoDataPart${level}`] || [];
    let capsuleChapter = null;

    const normalChapters = chapters.filter(item => {
      if (
        level === FRM_LEVELS.ONE &&
        (item.chapter_id === CAPSULE_VIDEO_ID || item.id === CAPSULE_VIDEO_ID)
      ) {
        capsuleChapter = item;
        return false;
      }
      return !item.mock_id;
    });

    const mockChapters = chapters.filter(item => item.mock_id);

    const normalCards = normalChapters.map((item, idx) =>
      this.createVideoCard({
        item,
        idx,
        type: "normal",
        level,
        ...state,
        toggleAlert,
        redirectToPlaylist
      })
    );

    const mockCards = mockChapters.map((item, idx) =>
      this.createVideoCard({
        item,
        idx,
        type: "mock",
        level,
        ...state,
        toggleAlert,
        redirectToPlaylist
      })
    );

    const capsuleCard = capsuleChapter
      ? this.createVideoCard({
        item: capsuleChapter,
        idx: normalCards.length + mockCards.length,
        type: "capsule",
        level,
        ...state,
        toggleAlert,
        redirectToPlaylist
      })
      : null;

    const cards = [...normalCards, ...mockCards];
    if (level === FRM_LEVELS.ONE) cards.push(capsuleCard);
    return cards.filter(Boolean);
  };

  render() {
    const { state } = this;
    const { isLoading, openPremiumPopup } = state;

    return (
      <div className="animated fadeIn">
        <ComponentHeader title={messages.VIDEOS} className="frm_title_logo_wrap">
          <img src={graphLogo} className="garpLogo" alt="full logo" />
        </ComponentHeader>
        {['1', '2'].map(level => (
          <div key={level}>
            <ComponentHeader title={messages[`FRM_TOPIC_PART_${level}`]} className="mt-3">
              <button
                className="btn btn-primary pointer_class"
                onClick={() => this.redirectToLastViewedVideo({ level })}
                disabled={state[`isButtonDisablePart${level}`]}
              >
                {state[`isButtonDisablePart${level}`] && <i className="fa fa-spinner fa-spin mr-1" />}
                {messages.GO_TO_MY_LAST_VIEWED_VIDEO}
              </button>
            </ComponentHeader>
            <LoaderWrapper isLoading={isLoading}>
              <Row className="video_lesson_wrap">
                {this.renderVideoCards({
                  state,
                  level,
                  toggleAlert: this.toggleAlert,
                  redirectToPlaylist: this.redirectToPlaylist
                })}
              </Row>
            </LoaderWrapper>
          </div>
        ))}
        {/* //* THIS IS FOR PREMIUM POPUP  */}
        <ModalComponent
          goPremium={this.goPremium}
          toggleAlert={this.toggleAlert}
          alert_status={openPremiumPopup}
          MessageContent={alertMessage.messageContent_frm}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Videos/index.jsx